import * as Yup from 'yup';


export interface IDayRangeModel {
  dayRange: number | null
  kmLimit: number | null
  overLimitFee: number | null
}

export interface IGeneralTariffModel {
  id: string
  rateName: string
  dayOne: IDayRangeModel | null
  dayTwo: IDayRangeModel | null
  dayThree: IDayRangeModel | null
  dayFour: IDayRangeModel | null
  dayFive: IDayRangeModel | null
  daySix: IDayRangeModel | null
  daySeven: IDayRangeModel | null
  actionDate: string | null
  cancellationDate: string | null
  discount: number | null
  rateGroup: string
  actionBranch: string
  startDate: string | null
  endDate: string | null
  scdwInsurance: boolean
  miniDamage: boolean
  theftIncluded: boolean
  scdwIncluded: boolean
  display: boolean
}

export const validationGeneralTariff = (existingTariffs: IGeneralTariffModel[]) =>
  Yup.object({
    rateName: Yup.string()
      .required('Tarife adı zorunludur')
      .test('unique-rateName', 'Aynı Tarife adı yazılamaz', function (value) {
        if (!value) return true
        const duplicate = existingTariffs.find(
          (t: IGeneralTariffModel) =>
            t.rateName.toLowerCase() === value.toLowerCase() &&
            t.id !== this.parent.id
        )
        return !duplicate
      }),
    rateGroup: Yup.string().required('Tarife Grubu zorunludur'),
    actionDate: Yup.date().required('İşlem Tarihi zorunludur'),
    cancellationDate: Yup.date().nullable(),
    startDate: Yup.date().required('Başlangıç tarihi zorunludur'),
    endDate: Yup.date()
      .required('Bitiş tarihi zorunludur')
      .min(Yup.ref('startDate'), 'Bitiş tarihi, başlangıç tarihinden önce olamaz'),

    dayOne: Yup.object({
      dayRange: Yup.number().required('Gün aralığı zorunludur'),
      kmLimit: Yup.number().required('Km sınırı zorunludur'),
      overLimitFee: Yup.number().required('Aşım bedeli zorunludur'),
    }).nullable(),
    dayTwo: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),
    dayThree: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),
    dayFour: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),
    dayFive: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),
    daySix: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),
    daySeven: Yup.object({
      dayRange: Yup.number().required(),
      kmLimit: Yup.number().required(),
      overLimitFee: Yup.number().required(),
    }).nullable(),

    discount: Yup.number().min(0, 'İndirim 0’dan küçük olamaz').nullable(),

    scdwInsurance: Yup.boolean(),
    miniDamage: Yup.boolean(),
    theftIncluded: Yup.boolean(),
    scdwIncluded: Yup.boolean(),
    display: Yup.boolean(),
  })





export const initialGeneralTariff: IGeneralTariffModel = {
  id: '',
  rateName: '',
  dayOne: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  dayTwo: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  dayThree: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  dayFour: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  dayFive: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  daySix: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  daySeven: { dayRange: 0, kmLimit: 0, overLimitFee:0 },
  actionDate: null,
  cancellationDate: null,
  discount: 0,
  rateGroup: '',
  actionBranch: '',
  startDate: '',
  endDate: '',
  scdwInsurance: false,
  miniDamage: false,
  theftIncluded: false,
  scdwIncluded: false,
  display: false,
}

export const TARIFF_GROUPS = [
  { value: 'Standart', label: 'Standart' },
  { value: 'Premium', label: 'Premium' },
  { value: 'Kurumsal', label: 'Kurumsal' },
  { value: 'Kampanya', label: 'Kampanya' },
  { value: 'Uzun Dönem', label: 'Uzun Dönem' },
];



export const RELATED_OFFICE = [{value: '-1', label: 'Yeni Genel Tarife'}] as const